module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-800italic.woff2?28a7dac2331454b658d6861582bf35e6";